export enum Api {
    Rest = 'rest',
    Graphql = 'graphql',
    Realtime = 'realtime',
}